export default __webpack_public_path__ + "static/media/texture_riprap_articulated.1df53c76.svg";